// Mutations cho module navigation
export default {
	/**
	 * Đặt flag điều hướng từ màn hình Báo cáo Bảng kê
	 * @param {Object} state - State hiện tại của module
	 * @param {Object} payload - Payload chứa thông tin điều hướng (ví dụ: { reportType: 'summary' | 'detail' })
	 */
	setBangKeNavigation(state, payload) {
		state.bangKeNavigation = payload;
	},

	/**
	 * Xóa flag điều hướng (one-shot pattern — clear ngay sau khi đọc xong)
	 * @param {Object} state - State hiện tại của module
	 */
	clearBangKeNavigation(state) {
		state.bangKeNavigation = null;
	}
};